import { ItemSheetExtraTag } from "@/consts/Estimate";

export const BadgeType = {
  [ItemSheetExtraTag.OWN_PRODUCT]: { color: "bg-dark-red", label: "자사제품" },
  [ItemSheetExtraTag.PAST_PURCHASE]: {
    color: "bg-blue-ThermoFisher",
    label: "과거데이터",
  },
  [ItemSheetExtraTag.GOOGLE_SEARCH]: {
    color: "bg-white",
    label: "구글 검색 데이터",
  },
  [ItemSheetExtraTag.FLOOR_PRICE]: { color: "bg-red", label: "Floor Price" },
  [ItemSheetExtraTag.CUSTOM_PRICE]: {
    color: "bg-yellow",
    label: "Custom Price",
  },
  [ItemSheetExtraTag.NEED_CONFIRM]: {
    color: "bg-gray-A",
    label: "체크 필요",
  },
} as const;

export type BadgeKeys = keyof typeof BadgeType;
